import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import { isBusinessUserLoggedIn } from "../store/slices/businessUser/slice";
import Header from "../components/NewHeader/NewHeader";
import Sidebar from "../screens/AdminPortal/utils/Sidebar";
import CategoryBar from "../components/CategoryBar/CategoryBar";
import {
  Content,
  HeaderWrapper,
  MainContainer,
} from "./BusinessUserLayout.styles";
import {
  selectedLocale,
  selectSidebarOpen,
} from "../store/slices/common/slice";

const BusinessUserLayout = () => {
  const location = useLocation();
  const loggedIn = useSelector(isBusinessUserLoggedIn);
  const [wasUserLoggedIn, setWasUserLoggedIn] = useState(false);
  const opened = useSelector(selectSidebarOpen);
  const locale = useSelector(selectedLocale);
  const ar = locale === "ar";

  useEffect(() => {
    if (loggedIn) {
      setWasUserLoggedIn(true);
    }
  }, [loggedIn]);

  let publicPath = "/";

  if (
    !wasUserLoggedIn &&
    location.pathname.includes("/marketplace/item-detail/")
  ) {
    publicPath = location.pathname
      .replace("/admin-portal", "")
      .replace("item-detail/", "");
  }

  const [padding, setPadding] = useState("4rem 4rem 8rem 4rem");

  useEffect(() => {
    const updatePadding = () => {
      if (window.innerWidth < 870) {
        setPadding("2rem 2rem 8rem 2rem");
      } else {
        setPadding("4rem 4rem 8rem 4rem");
      }
    };

    updatePadding();

    window.addEventListener("resize", updatePadding);

    return () => window.removeEventListener("resize", updatePadding);
  }, []);

  return loggedIn ? (
    <MainContainer
      $column
      style={{
        alignItems:
          location.pathname.includes("marketplace/item-detail") && "center",
      }}
    >
      <HeaderWrapper>
        <Header
          sendGift={
            location.pathname.includes("section-items") ||
            location.pathname.includes("category-items") ||
            location.pathname.includes("select-gifts")
          }
        />
      </HeaderWrapper>
      {!location.pathname.includes("/marketplace/item-detail") &&
        !location.pathname.includes("cart") &&
        !location.pathname.includes("delivery-details") && (
          <>
            {!location.pathname.includes("select-gifts") &&
            !location.pathname.includes("section-items") &&
            !location.pathname.includes("category-items") ? (
              <Sidebar $ar={ar} />
            ) : (
              <CategoryBar $ar={ar} />
            )}
          </>
        )}
      <Content
        $ar={ar}
        $loggedIn={loggedIn}
        $open={
          location.pathname.includes("delivery-details") ||
          location.pathname.includes("cart")
            ? false
            : opened
        }
        style={{
          alignItems:
            location.pathname.includes("marketplace/item-detail") && "center",
          padding:
            location.pathname.includes("marketplace/item-detail") && padding,
        }}
      >
        <Outlet />
      </Content>
    </MainContainer>
  ) : (
    loggedIn === false && <Navigate to={publicPath} replace />
  );
};

export default BusinessUserLayout;
